<template lang="pug">
	form.v-form.form(v-if="form"
			novalidate
			autocomplete="off"
			:class="[className || form.className, {'form--success': form.success}]"
			@submit.prevent="submit")
		v-loader.loader--white(:loading="loading")
		template(v-if="form.success")
			.form__success-message(v-html="form.message")
		template(v-if="form.errors && form.errors.form && form.errors.form.length")
			.form__form-errors
				template(v-if="Array.isArray(form.errors.form) && form.errors.form.length")
					template(v-for="error in form.errors.form")
						.form__form-error.flc(v-html="error")
				template(v-else)
					.form__form-error.flc(v-html="form.errors.form")
		template(v-if="form")
			.form__header.flc(v-if="form.title || form.note")
				.form__header-title-wrap
					h2.form__header-title.flc(v-if="form.title") {{form.title}}
				.form__header-note.flc(v-if="form.note" v-html="form.note")
				template(v-if="$slots['tabs']")
					.form__tabs
						slot(name="tabs")
			.form__main.flc(v-if="form.groups && form.groups.length")
				.form__groups
					template(v-for="(group, groupIndex) in form.groups" :key="groupIndex")
						.form__group(v-if='fieldGroupCount(group.id)' :style="{width: group.width || null}")
							h3.form__group-title.flc(v-if="group.title")
								.form__group-number(v-if="group.number") {{group.number}}
								.form__group-title-text {{group.title}}
							.form__group-body.flc
								.form__fields
									template(v-for="(field, fieldIndex) in form.fields" :key="fieldIndex")
										template(v-if="field.groupId === group.id && field.type!='hidden'")
											.form__field.flc(:style="{width: field.width || null}")
												v-field(:field="field"
														v-model="field.value"
														:errors="getFieldError(field)"
														@fileinput="fileInput(field, $event)"
														@fileremove="fileRemove(field, $event)"
														@remove="valueRemove(field, $event)"
														@update:model-value="fieldChanged(field, $event)")
							.form__group-note(v-if="group.note")
								v-svg-icon.form__group-note-icon(icon="note-fill")
								.form__group-note-text(v-html="group.note")
			.form__footer.flc(v-if="form.buttons && form.buttons.length" :class="{'form__footer--mt-big': form.success}")
				template(v-if="form.requireConfirm && form.requireConfirmText && view !== 'basket-form'")
					.form__confirm
						v-field.field--big-checkbox(:field="computedConfirmField"
								v-model="confirmValue"
								@update:model-value="confirmed = !confirmed")
				.form__actions
					template(v-for="(button, buttonIndex) in form.buttons" :key="buttonIndex")
						.form__action(:style="{'width': button.width}")
							button(:type="button.type || 'submit'"
									:class="button.className || 'btn btn--primary'"
									:disabled="button.disabled ? true : (disableSubmitBtn ? isDisabledSubmitBtn : (form.requireConfirm ? !confirmed : null))"
									:data-modal-url="button.modalUrl"
									:data-modal-data="button.modalData"
									@click="buttonClickHandler(button)")
								.btn__text {{button.text}}
			template(v-if="$slots['additional']")
				slot(name="additional")
</template>

<script>
import initAnchors from '../scripts/helpers/anchors.js';
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller';
import {mapActions} from "vuex";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		mode: {
			type: String,
			default: null
		},

		product: {
			type: Object,
			default: null
		},

		productId: {
			type: [String, Number],
			default: null
		},

		className: {
			type: String,
			default: null
		},

		disableSubmitBtn: {
			type: Boolean,
			default: false
		},

		view: {
			type: String,
			default: null
		}
	},

	emits: [
		'success'
	],

	data() {
		return {
			form: null,
			localFormData: new FormData(),
			modalTimeout: null,
			confirmValue: [],
			confirmed: false,
			savedFileKeys: [],
			hideNameValue: false,
			hideName: false,
			isDisabledSubmitBtn: false,
			submitTimeout: false,
		};
	},

	computed: {
		computedHideUsernameField() {
			return {
				type: 'check-list',
				value: [],
				label: null,
				options: [
					{
						'value': '1',
						'text': this.form.hideUsername
					}
				]
			};
		},

		computedConfirmField() {
			return {
				type: 'check-list',
				value: [],
				label: null,
				options: [
					{
						'value': '1',
						'text': this.form.requireConfirmText
					}
				]
			};
		}
	},

	methods: {
		fieldGroupCount(groupID){
			let fields = this.form.fields.filter((field) => field.groupId === groupID && field.type !== 'hidden');
			return fields ? fields.length : 0;
		},

		buttonClickHandler(button) {
			if (button.event) {

			}
		},

		...mapActions({
			addToFavorites: 'favorite/add'
		}),

		openActionModal() {
			controller.openModal({
				className: "modal--right",
				component: {
					name: 'v-form',
					props: {
						dataSource: this.form.formAction.remote,
						bxajaxid: this.form.formAction.bxajaxid
					}
				}
			});
		},

		getFieldError(field) {
			if (this.form.errors && this.form.errors.fields) {
				let filteredErrors = this.form.errors.fields.filter((item) => item.name === field.name);
				return filteredErrors.length ? filteredErrors : null;
			} else {
				return null;
			}
		},

		scrollToTop() {
			const $closestFormSection = this.$el?.closest('.form-section');
			if ($closestFormSection) {
				let yOffset = -160;
				if (this.isMd) {
					yOffset = -10;
				}
				window.scrollTo({top: $closestFormSection.getBoundingClientRect().top + window.pageYOffset + yOffset, behavior: 'smooth'});
			}
		},

		scrollToFirstError() {
			if (!this) {
				return;
			}
			if (document.body.classList.contains('state--modal-open')) {
				return;
			}
			const $errorFields = this.$el.querySelectorAll('.form-error');
			if ($errorFields.length > 0) {
				const $firstErrorField = $errorFields[0];
				const yOffset = -10;
				const coordY = $firstErrorField.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({top: coordY, behavior: 'smooth'});
			} else {
				window.scrollTo({top: 0, behavior: 'smooth'});
			}
		},

		proxyFieldName(name) {
			return `state[form][${name}]`;
		},

		resetState() {
			this.localFormData = new FormData();
			this.confirmValue = [];
			this.confirmed = false;
			this.savedFileKeys = [];
		},

		dataSet(data) {
			if (data.success) {
				if (data.resetState) {
					this.resetState();
				}
				this.$emit('success');
				if (data.emit_event) {
					controller.emitCustomEvent(data.emit_event);
				}
				if (data.autoCloseModalAfterThreeSeconds) {
					setTimeout(() => {
						controller.closeModal();
					}, 3000);
				}
			}
			if (data.success && typeof (data.modalTimeout) !== 'undefined' && data.modalTimeout > 0) {
				clearTimeout(this.modalTimeout);
				this.modalTimeout = setTimeout(() => {
					controller.closeModal();
				}, data.modalTimeout);
			}
			if (data.success && data.modal) {
				window.modalController.closeAll().then(() => {
					// открыть модальное окно с сообщением об успешной отправке формы
					if (data.modal.url) {
						controller.openModal({
							url: data.modal.url,
							className: data.modal.className,
							content: data.message,
							canCloseOutside: typeof (data.canCloseOutside) != 'undefined' ? data.canCloseOutside : true
							//component: data.modal.component
						});
					} else {
						controller.openModal({
							className: data.modal.className,
							content: data.message,
							//component: data.modal.component
						});
					}
				});
				this.form = data;
				return;
			}
			if (data.success && data.closeModal) {
				controller.closeModal();
				return;
			}
			this.form = data;
			// проброс ошибок в данные поля
			if (this.form?.fields?.length) {
				this.form.fields.forEach((field) => {
					field.errors = this.getFieldError(field)
				})
			}
			if (data.success && data.updataFavorites && data.productId) {
				this.addToFavorites({
					id: data.productId,
					lists: data.lists
				})
			}
			if (this.disableSubmitBtn) {
				this.isDisabledSubmitBtn = this.form.fields.find(field => field.type === 'check-list' && field.lockSubmit)?.value?.length === 0;
			}
			if (data.success) {
				this.scrollToTop();
			}
			this.$nextTick(() => {
				initAnchors(this.$el);
			});
		},

		submit(options = {}) {
			if (this.form && this.form.fields) {
				// для отправки файлов придется держать в памяти неизменный localFormData
				// перед отправкой нужно удалить старые значения из localFormData
				// т.к. localFormData.append добавляет новые значения к существующим
				// а localFormData.set не позволила бы работать с массивами типа NAME[]
				for (let key of Array.from(this.localFormData.keys())) {
					if (!this.savedFileKeys.includes(key)) { // если поле не файл то очищать значение в localFormData
						console.log(key);
						this.localFormData.delete(key);
					}
				}
				this.form.fields.forEach(field => {
					let key = this.proxyFieldName(field.name);
					if (field.multiple) {
						key = this.proxyFieldName(field.name.replace('[]', ''));
					}
					if (!field.value) {
						field.value = '';
					}
					if (field.type !== 'file') {
						if (Array.isArray(field.value)) {
							field.value.forEach((val, index) => {
								this.localFormData.append(`${key}[${index}]`, val);
							});
						} else {
							this.localFormData.append(key, field.value);
						}
					}
				});
			}
			this.localFormData.set('state[action]', options.action || 'submit');
			this.localFormData.set('bxajaxid', (this.form.bxajaxid ? this.form.bxajaxid : this.bxajaxid));
			if (this.productId) {
				this.localFormData.set('productId', this.productId);
			}
			if (this.confirmed) {
				this.localFormData.append('confirmed', 1);
			} else {
				this.localFormData.delete('confirmed');
			}
			this.dataLoad({
				url: this.form.remote,
				data: this.localFormData,
				delay: true
			});
		},

		fieldChanged(field) {
			if (field.autosubmit) {
				this.autoSubmit(field);
			}
			if (field.submit) {
				this.submit();
			}
			if (this.disableSubmitBtn) {
				this.isDisabledSubmitBtn = this.form.fields.find(field => field.type === 'check-list' && field.lockSubmit)?.value?.length === 0;
			}
		},

		fileInput(field, e) {
			for (let i = 0; i < e.target.files.length; i++) {
				let saveKey = this.proxyFieldName(field.name) + '[' + e.key + ']';
				let saveValue = e.target.files[i].path || e.target.files[i];
				this.savedFileKeys.push(saveKey);
				this.localFormData.append(saveKey, saveValue);
			}
			if (field.autosubmit && !e.nosubmit) {
				this.autoSubmit(field);
			}
		},

		fileRemove(field, e) {
			this.localFormData.delete(this.proxyFieldName(field.name) + '[' + e.key + ']');
			if (field.autosubmit && !e.nosubmit) {
				this.autoSubmit(field);
			}
		},

		autoSubmit(field) {
			clearTimeout(this.submitTimeout);
			if (field.timeout && parseInt(field.timeout)) {
				this.submitTimeout = setTimeout(() => {
					this.submit({action: 'autosubmit'});
				}, field.timeout);
				return;
			}
			this.submit({action: 'autosubmit'});
		},

		valueRemove(field, e) {
			// remove error of removed value
			if (field.errors && field.errors.length) {
				field.errors.splice(e, 1);
			}
		}
	}
};
</script>